import React from "react";
import styled from "styled-components";
import iconExport from "../../../images/icon-export.svg";

const Image = styled.img`
  padding: ${props => props.padding} ${props => props.padding} 0;
  width: ${props => props.width || "23px"};
  height: ${props => props.height || "23px"};
  ${({disableExportButton}) => disableExportButton && `
      opacity: 0.45;
  `}
`;

export const ExportIcon = ({padding, width, height}) => {
  return <Image padding={padding}
                width={width}
                height={height}
                src={iconExport}/>
};